var _text, _text2, _text3, _text4, _text5, _text6, _text7, _text8, _text9, _text10, _text11, _text12, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgYears = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1720,
    height: 144,
    viewBox: "0 0 1720 144",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "_2001",
    "data-name": 2001,
    transform: "translate(49.5 61)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNowDisplay-Regular, Helvetica Now Display"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2001"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    id: "_2002-2008",
    "data-name": "2002-2008",
    transform: "translate(119.328 61)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNowDisplay-Regular, Helvetica Now Display",
    opacity: 0.495
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2002-2008"))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    id: "_2010-2011",
    "data-name": "2010-2011",
    transform: "translate(329.328 61)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNowDisplay-Regular, Helvetica Now Display",
    opacity: 0.495
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2010-2011"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    id: "_2013-2015",
    "data-name": "2013-2015",
    transform: "translate(545.328 61)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNowDisplay-Regular, Helvetica Now Display",
    opacity: 0.495
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2013-2015"))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    id: "_2018",
    "data-name": 2018,
    transform: "translate(889.414 61)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNowDisplay-Regular, Helvetica Now Display",
    opacity: 0.495
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2018"))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    id: "_2017",
    "data-name": 2017,
    transform: "translate(796.414 61)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNowDisplay-Regular, Helvetica Now Display"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2017"))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    id: "_2019",
    "data-name": 2019,
    transform: "translate(1054.414 61)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNowDisplay-Regular, Helvetica Now Display"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2019"))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    id: "_2020",
    "data-name": 2020,
    transform: "translate(1367.414 61)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNowDisplay-Regular, Helvetica Now Display"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2020"))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    id: "_2021",
    "data-name": 2021,
    transform: "translate(1572.414 61)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNowDisplay-Regular, Helvetica Now Display"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2021"))), _text10 || (_text10 = /*#__PURE__*/React.createElement("text", {
    id: "_2016",
    "data-name": 2016,
    transform: "translate(678.414 61)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNowDisplay-Regular, Helvetica Now Display"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2016"))), _text11 || (_text11 = /*#__PURE__*/React.createElement("text", {
    id: "_2012",
    "data-name": 2012,
    transform: "translate(457.414 61)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNowDisplay-Regular, Helvetica Now Display"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2012"))), _text12 || (_text12 = /*#__PURE__*/React.createElement("text", {
    id: "_2009",
    "data-name": 2009,
    transform: "translate(242.414 61)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNowDisplay-Regular, Helvetica Now Display"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 18
  }, "2009"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_935",
    "data-name": "Path 935",
    d: "M-12042-8248.43h121.244",
    transform: "translate(-8140.016 12054.378) rotate(90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_936",
    "data-name": "Path 936",
    d: "M-12042-8248.43h121.244",
    transform: "translate(-8040.016 12054.378) rotate(90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_937",
    "data-name": "Path 937",
    d: "M-12042-8248.43h121.244",
    transform: "translate(-7833.016 12054.378) rotate(90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_939",
    "data-name": "Path 939",
    d: "M-12042-8248.43h121.244",
    transform: "translate(-7719.016 12054.378) rotate(90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_940",
    "data-name": "Path 940",
    d: "M-12042-8248.43h121.244",
    transform: "translate(-7614.016 12054.378) rotate(90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_941",
    "data-name": "Path 941",
    d: "M-12042-8248.43h121.244",
    transform: "translate(-7496.016 12054.378) rotate(90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_942",
    "data-name": "Path 942",
    d: "M-12042-8248.43h121.244",
    transform: "translate(-7378.016 12054.378) rotate(90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_943",
    "data-name": "Path 943",
    d: "M-12042-8248.43h121.244",
    transform: "translate(-7303.016 12054.378) rotate(90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_944",
    "data-name": "Path 944",
    d: "M-12042-8248.43h121.244",
    transform: "translate(-7040.016 12054.378) rotate(90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_945",
    "data-name": "Path 945",
    d: "M-12042-8248.43h121.244",
    transform: "translate(-6705.016 12054.378) rotate(90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_938",
    "data-name": "Path 938",
    d: "M-12042-8248.43h121.244",
    transform: "translate(-7935.016 12054.378) rotate(90)",
    fill: "none",
    stroke: "#8f8f8f",
    strokeWidth: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1977",
    "data-name": "Rectangle 1977",
    fill: "none",
    stroke: "#fdfdfd",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1720,
    height: 144,
    rx: 72,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7.5,
    y: 7.5,
    width: 1705,
    height: 129,
    rx: 64.5,
    fill: "none"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgYears, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Years.8359514d.svg";
export { ForwardRef as ReactComponent };